import { useMerchant } from 'hooks/context/merchant';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export const MerchantTitle: React.FC<{ i18nKey: string }> = ({ i18nKey }) => {
  const { merchant } = useMerchant();
  const { t } = useTranslation();

  return (
    <Helmet>
      <title>{t(i18nKey, { merchantName: merchant?.name })}</title>
    </Helmet>
  );
};
